import { useEffect } from "react";
import { useAuth } from "@clerk/react";

import {
  setSessionTokenProvider,
  clearSessionTokenProvider,
} from "../services/apiClient";

/**
 * Hands Clerk's `getToken` to the axios layer.
 *
 * Renders nothing. It exists because axios interceptors run outside React, so
 * they cannot call a hook; this component bridges the two while staying inside
 * `<ClerkProvider>`.
 */
function ApiAuthBridge() {
  const { getToken, isSignedIn } = useAuth();

  useEffect(() => {
    if (!isSignedIn) {
      clearSessionTokenProvider();
      return undefined;
    }

    setSessionTokenProvider(() => getToken());

    return () => {
      clearSessionTokenProvider();
    };
  }, [getToken, isSignedIn]);

  return null;
}

export default ApiAuthBridge;
